const Lockr = class {
  setPrefix(prefix){
    this.prefix=prefix;
  }
  getPrefix(){
    return this.prefix;
  }
   _getPrefixedKey(key, options) {
    options = options || {};
    if (options.noPrefix) {
      return key;
    } else {
      return this.prefix + key;
    }
  }
   set(key, value, options) {
    var query_key = this._getPrefixedKey(key, options);
    try {
      localStorage.setItem(query_key, JSON.stringify({
        data: value
      }));
    } catch (e) {
      if (console)
        console.warn(
          "Lockr didn't successfully save the '{" +
          key +
          ": " +
          value +
          "}' pair, because the localStorage is full."
        );
    }
  }
   get(key, missing, options) {
    var query_key = this._getPrefixedKey(key, options),
      value;
    try {
      // console.log('localStorage',localStorage)
      let v = localStorage.getItem(query_key);
      if (!v) {
        v = ''
      }
      value = JSON.parse(v);
    } catch (e) {
      try {
        if (localStorage[query_key]) {
          value = {
            data: localStorage.getItem(query_key)
          };
        } else {
          value = null;
        }
      } catch (error) {
        console.warn(error)
      }
    }
    if (!value) {
      return missing;
    } else if (typeof value === "object" && typeof value.data !== "undefined") {
      return value.data;
    }
  }
   sadd(key, value, options) {
    var query_key = this._getPrefixedKey(key, options),
      json;

    var values = this.smembers(key);

    if (values.indexOf(value) > -1) {
      return null;
    }

    try {
      values.push(value);
      json = JSON.stringify({
        data: values
      });
      localStorage.setItem(query_key, json);
    } catch (e) {
      console.log(e);
      if (console)
        console.warn(
          "Lockr didn't successfully add the " +
          value +
          " to " +
          key +
          " set, because the localStorage is full."
        );
    }
  }

   smembers(key, options) {
    var query_key = this._getPrefixedKey(key, options),
      value;

    try {
      let v = localStorage.getItem(query_key)
      if(!v){
        v=''
      }
      value = JSON.parse(v);
    } catch (e) {
      value = null;
    }

    return value && value.data ? value.data : [];
  }

   sismember(key, value, options) {
    return this.smembers(key).indexOf(value) > -1;
  }

   keys() {
    try {
      var keys = [];
      var allKeys = Object.keys(localStorage);

      if (this.prefix.length === 0) {
        return allKeys;
      }

      allKeys.forEach( (key) =>{
        if (key.indexOf(this.prefix) !== -1) {
          keys.push(key.replace(this.prefix, ""));
        }
      });

      return keys;
    } catch (e) {
      //TODO handle the exception
    }

  }

   getAll(includeKeys) {
    var keys = this.keys();

    if (includeKeys) {
      return keys?.reduce( (accum, key)=> {
        var tempObj = {};
        tempObj[key] = this.get(key);
        accum.push(tempObj);
        return accum;
      }, []);
    }

    return keys?.map( (key)=> {
      return this.get(key);
    });
  }

   srem(key, value, options) {
    var query_key = this._getPrefixedKey(key, options),
      json,
      index;

    var values = this.smembers(key, value);

    index = values.indexOf(value);

    if (index > -1) values.splice(index, 1);

    json = JSON.stringify({
      data: values
    });

    try {
      localStorage.setItem(query_key, json);
    } catch (e) {
      if (console)
        console.warn(
          "Lockr couldn't remove the " + value + " from the set " + key
        );
    }
  }

   rm(key) {
    try {
      var queryKey = this._getPrefixedKey(key);

      localStorage.removeItem(queryKey);
    } catch (e) {
      //TODO handle the exception
    }

  }

   flush(excludeKeys) {
    try {
      if (this.prefix.length) {
        let arr = this.keys()||[]
        arr.forEach( (key) =>{
          try {
            let flg = !excludeKeys.some(o=>o===key)
          if(flg){
            let _key = this._getPrefixedKey(key)
            localStorage.removeItem(_key);
          }
          } catch (error) {
            console.error(error)
          }
        });
      } else {
        localStorage.clear();
      }
    } catch (e) {
      //TODO handle the exception
    }

  }
}

export default Lockr;